// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getISODay as fn } from "../getISODay.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getISODayWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default getISODayWithOptions;
